// Public storefront transport. AI credentials stay inside the Edge Function.
export const ADVISOR_BASE='https://ifbccirldjwiuztxfcxr.supabase.co';
export function isPublicKey(key){
  if(/^sb_publishable_[\w-]+$/.test(key||''))return true;
  try{return JSON.parse(atob(key.split('.')[1].replace(/-/g,'+').replace(/_/g,'/'))).role==='anon';}catch{return false;}
}
export function createStorefrontChat({key,fetcher=globalThis.fetch,storage,now=Date.now}){
  if(!isPublicKey(key))throw Error('invalid_public_key');
  const storageKey='uniquee-advisor-auth-v1';let session=null,pending=null;
  try{session=JSON.parse(storage?.getItem(storageKey)||'null');}catch{}
  const save=data=>{session={access_token:data.access_token,refresh_token:data.refresh_token,expires_at:now()/1000+Number(data.expires_in||3600)};try{storage?.setItem(storageKey,JSON.stringify(session));}catch{}return session;};
  async function auth(path,body){
    const response=await fetcher(ADVISOR_BASE+'/auth/v1/'+path,{method:'POST',headers:{apikey:key,'Content-Type':'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(15000)});
    const data=await response.json();if(!response.ok)throw Error('advisor_sign_in_unavailable');return save(data);
  }
  async function getSession(force=false){
    if(!force&&session?.access_token&&session.expires_at>now()/1000+60)return session;
    if(pending)return pending;
    pending=(async()=>{
      if(session?.refresh_token){
        try{return await auth('token?grant_type=refresh_token',{refresh_token:session.refresh_token});}
        catch(error){throw error;} // Never bypass a failed refresh by creating another identity.
      }
      return auth('signup',{data:{purpose:'storefront-fragrance-advisor'}});
    })();try{return await pending;}finally{pending=null;}
  }
  return async input=>{
    for(let attempt=0;attempt<2;attempt++){
      const current=await getSession(attempt===1);
      const response=await fetcher(ADVISOR_BASE+'/functions/v1/fragrance-advisor-mistral',{method:'POST',headers:{apikey:key,Authorization:'Bearer '+current.access_token,'Content-Type':'application/json'},body:JSON.stringify(input),signal:AbortSignal.timeout(110000)});
      if(response.status===401&&attempt===0)continue;
      const result=await response.json();if(!response.ok)throw Error(result.error||'advisor_unavailable');return result;
    }
  };
}
if(typeof document!=='undefined'){
  const config=document.getElementById('uniquee-advisor-config');
  if(config){
    try{
      const settings=JSON.parse(config.textContent);let storage;try{storage=window.sessionStorage;}catch{}
      const chat=createStorefrontChat({key:settings.publicKey,storage});
      const {mountAdvisor}=await import(settings.widgetUrl);
      mountAdvisor({chat,country:settings.country,cssUrl:settings.cssUrl});
    }catch{ /* Invalid/incomplete configuration must not affect shopping. */ }
  }
}
